export const CONTACT_CONFIG = {
  supportEmail: 'support@roftofficial.com',
  privacyEmail: 'privacy@roftofficial.com',
  businessEmail: 'business@roftofficial.com',
  accountEmail: 'account@roftofficial.com',
  internalEmail: 'ylabs@roftofficial.com',
  legalOperatorName: 'YLabs'
};
